import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { Banner } from '../../models/banner';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { SwiperConfigInterface, SwiperNavigationInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
declare var platform;

@Component({
  selector: 'app-notices',
  templateUrl: './notices.component.html',
  styleUrls: ['./notices.component.scss']
})

export class NoticesComponent implements OnInit {

  constructor(private routingService: RoutingService
    , private renderer:Renderer2) { }

  @Input() notices: Array<Banner>
  config: SwiperConfigInterface = {
    slidesPerView: 'auto',        
    navigation: false,
    pagination: false
  };

  private navigation: SwiperNavigationInterface = {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }

  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  }

  ngOnInit() {
    if (platform == 'browser') {
      this.config.navigation = this.navigation;
      this.config.pagination = this.pagination;
    }
    this.notices = this.notices.filter(o => o.message_type == 1);
  }

  readMoreClicked(banner: Banner) {
    if (banner.message_type == 1) {
      let route = new PrifactRoute();
      route.primary_command = ['pages', 'notices', banner.id];
      route.append_current_url_to_history = false;
      this.routingService.navigate(route);
      this.renderer.addClass(document.body, 'second-page');
    }
  }
}
